import { Injectable } from '@angular/core';
import { ApiClient } from '../http/api-client';

import { AppSettings } from '../../app.settings';
import { SchemaComparison, SchemaPushPlan } from './types';

type Response<T> = Promise<{
  status: string;
  data: T;
}>;

@Injectable({
  providedIn: 'root',
})
export class EnvSyncService {
  constructor(private baseRestAngular: ApiClient, private restAngular: ApiClient) {
    this.restAngular = this.getCustomRestAngular();
  }

  private getCustomRestAngular() {
    return this.baseRestAngular.withBaseUrl(AppSettings.getEndpoint());
  }

  listServices(): Response<string[]> {
    return this.restAngular.one('v5').one('env-sync', 'services').get().toPromise();
  }

  compareSchemas(serviceName: string): Response<SchemaComparison[]> {
    return this.restAngular
      .one('v5')
      .one('env-sync')
      .one('services', serviceName)
      .one('compare')
      .get()
      .toPromise();
  }

  pushChanges(serviceName: string, plans: SchemaPushPlan[]): Response<void> {
    return this.restAngular
      .one('v5')
      .one('env-sync')
      .one('services', serviceName)
      .one('push')
      .customPOST(plans)
      .toPromise();
  }
}
